import { useEffect, useRef } from 'react'
import { useBaiduMap } from './BaiduMap'

export interface BaiduMarkerProps {
    position: { lat: number; lng: number }
    icon?: {
        url: string
        scaledSize?: { width: number; height: number }
    }
    title?: string
    opacity?: number
    animation?: 'BOUNCE' | 'DROP' | null
    onClick?: () => void
}

const BaiduMarker: React.FC<BaiduMarkerProps> = ({
    position,
    icon,
    title,
    opacity = 1,
    animation,
    onClick
}) => {
    const map = useBaiduMap()
    const markerRef = useRef<any>(null)

    useEffect(() => {
        if (!map || !window.BMapGL) return

        const point = new window.BMapGL.Point(position.lng, position.lat)

        let markerIcon: any = undefined
        if (icon?.url) {
            const size = icon.scaledSize || { width: 32, height: 32 }
            markerIcon = new window.BMapGL.Icon(
                icon.url,
                new window.BMapGL.Size(size.width, size.height)
            )
        }

        const marker = new window.BMapGL.Marker(point, {
            icon: markerIcon,
            title: title || '',
        })

        if (opacity !== 1) {
            marker.setOpacity(opacity)
        }

        if (animation === 'BOUNCE') {
            marker.setAnimation(window.BMAP_ANIMATION_BOUNCE)
        }

        if (onClick) {
            marker.addEventListener('click', onClick)
        }

        map.addOverlay(marker)
        markerRef.current = marker

        return () => {
            if (onClick) {
                marker.removeEventListener('click', onClick)
            }
            map.removeOverlay(marker)
            markerRef.current = null
        }
    }, [map, position.lat, position.lng, icon?.url, icon?.scaledSize?.width, icon?.scaledSize?.height, title, opacity, animation, onClick])

    return null
}

export default BaiduMarker
